'use client'

import { KachProvider } from 'kach-components'
import { useAtom } from 'jotai'
import { authAtom } from '../atoms/auth.atom'
import { jobsAtom } from '../atoms/jobs.atom'
import { GLOBAL_SCOPE_JOTAI } from './providers'
import { defaultContext } from '@tanstack/react-query'

interface KachProviderWrapperProps {
  children: React.ReactNode
}

export function KachProviderWrapper({ children }: KachProviderWrapperProps) {
  const [auth] = useAtom(authAtom, GLOBAL_SCOPE_JOTAI)
  const [jobsData] = useAtom(jobsAtom, GLOBAL_SCOPE_JOTAI)

  return (
    <KachProvider
      defaultContext={defaultContext}
      jobs={jobsData?.jobs || []}
      auth={auth}
    >
      {children}
    </KachProvider>
  )
}
